import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MoveLeft, Plus } from "lucide-react";
import TeamMembersList from "./TeamMembersList";
import styles from "./TeamSettings.module.css";

const HARDCODED_JOIN_CODE = "DEMO-JOIN-CODE-5HK2";

const HARDCODED_OVERVIEW_EMAILS = [
  "alice.wong@example.com",
  "ben.carter@example.com",
  "chloe.martin@example.com",
  "david.patel@example.com",
  "eva.schmidt@example.com",
];

const TEAM_GROUPS = [
  "Engineering",
  "Transport",
  "Business",
  "Support",
] as const;

function slugify(name: string) {
  return name.toLowerCase().replace(/\s+/g, "-");
}

export default function SettingsTeamOverview() {
  const navigate = useNavigate();
  const { teamKey } = useParams<{ teamKey: string }>();

  const title = (() => {
    if (!teamKey) return "teams overview";
    const label = TEAM_GROUPS.find((t) => slugify(t) === teamKey);
    return label ? `${label} — overview` : "teams overview";
  })();

  const overviewUsers = HARDCODED_OVERVIEW_EMAILS.map((email, i) => ({
    id: `overview-email-${i}`,
    email,
    status: "active",
    uid: `overview-email-${i}`,
  }));

  return (
    <>
      <div className="settings-element-header">
        <MoveLeft
          onClick={() => navigate("/app/settings/teams")}
          className={styles["back-button"]}
        />

        <p className={`settings-element-title page-title`}>{title}</p>

        <div></div>
        <Plus className={styles["hidden-plus-button"]} />
      </div>

      <div style={{ marginLeft: "16px", marginRight: "16px" }}>
        <h4>Users can join with code: {HARDCODED_JOIN_CODE}</h4>

        <TeamMembersList demoUsers={overviewUsers} />
      </div>
    </>
  );
}
